import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useFetcher, useNavigate } from "react-router-dom";

import {Provider} from 'react-redux';
import store, { persistor } from './redux/store';
import {PersistGate} from 'redux-persist/integration/react';
import Routerlist from "./router/Router";

import Popup from "./redux-components/Popup";
import Loading from "./redux-components/Loading";
import { GoogleOAuthProvider } from '@react-oauth/google';

import "./css/common.css";
import "./css/header.css";
import "./css/footer.css";
import "./css/layout.css";
import "./css/productdetails.css";
import "./css/writefrom.css";
import "./css/animations.css";
import "./css/contract.css";
import "./css/response.css";
import "./css/toastuicss.css";
// 커뮤니티 css
import "./css/Community.css";

function App() {
	return (
		<GoogleOAuthProvider clientId="945934570166-11hl5lcshl1n0fdea3sj6oj3plrloqt0.apps.googleusercontent.com">
		<Provider store={store}>
			<PersistGate persistor={persistor}>
				<Routerlist />
				<Loading />
        		<Popup />
			</PersistGate>
		</Provider>
		</GoogleOAuthProvider>
	);
}

export default App;
/*
{
    "Version": "2012-10-17",
    "Statement": [
        {
            "Sid": "Stmt1586072470528",
            "Effect": "Allow",
            "Principal": "*",
            "Action": [
                "s3:ListBucket",
                "s3:GetObject",
                "s3:PutObject"
            ],
            "Resource": [
                "arn:aws:s3:::aplynxs3/*",
                "arn:aws:s3:::aplynxs3"
            ],
            "Condition": {
                "StringLike": {
                    "aws:Referer": [
                        "http://localhost:3000/",
                        "http://localhost:3001/",
                        "http://ec2-13-209-84-64.ap-northeast-2.compute.amazonaws.com:3000/*",
                        "https://maemul.net/",
                        "https://www.maemul.net/",
                        "https://admin.maemul.net/",
                        "https://api.maemul.net/"
                    ]
                }
            }
        },
        {
            "Effect": "Allow",
            "Principal": {
                "AWS": "arn:aws:iam::059123748026:user/aplynxcopyuser"
            },
            "Action": "s3:ListBucket",
            "Resource": "arn:aws:s3:::aplynxs3"
        }
    ]
}
*/